import { MainHeader as MainHeaderSkeleton } from "@circle-react-uikit/SkeletonLoader/skeletons/MainHeader";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";
import {
  isBasicPostsSpace,
  isEventsSpace,
} from "@circle-react/helpers/spaceHelpers";

import { MobileAppBar } from "@/react/components/Layout/AppBar/MobileAppBar";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import { useIsLoadingAppData } from "@/react/hooks/useIsLoadingAppData";
import { useSpaceSlugFromUrl } from "@/react/hooks/useSpaceSlugFromUrl";

import { useIsAppBarVisible } from "../useIsAppBarVisible";

export const AppBar = () => {
  const slug = useSpaceSlugFromUrl();
  const spacesContext = useSpacesContext();

  const space = spacesContext.helpers.findBy({ slug });
  const isAppBarVisible = useIsAppBarVisible();
  const isLoadingAppData = useIsLoadingAppData();

  if (!isAppBarVisible) {
    return null;
  }

  if (isLoadingAppData) {
    return (
      <header className={anchorClassNames("header")}>
        <MainHeaderSkeleton
          showMemberAvatarsRow={
            space ? isEventsSpace(space) || isBasicPostsSpace(space) : false
          }
        />
      </header>
    );
  }

  return <MobileAppBar />;
};
